<div class="content-container">
  <router-outlet></router-outlet>
</div>
<session-timer-popup warningMessage="Your session will expire in" expiredMessage="Your session has expired."
  labelCloseButton="Close" labelLogoutButton="Logout" labelKeepWorking="Keep Working" labelSignInAgain="Sign In Again">
</session-timer-popup>